import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormControl from './FormControl';
import { Field, FormikConsumer } from 'formik';

class TextField extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    if (this.props.onChangeCallback) {
      this.props.onChangeCallback(this.props.name, e.target.value);
    }
  }

  hasTouched(name, touched) {
    let hasTouched = false;

    if (name.indexOf('phones') === -1) {
      hasTouched = touched.hasOwnProperty(name);
    } else {
      const parts = name.split('.');

      if (parts.length === 3 && parts[0] === 'phones') {
        hasTouched = touched.hasOwnProperty(parts[0]) && touched[parts[0]].hasOwnProperty(parts[1]);
      }
    }

    return hasTouched;
  }

  hasError(name, errors) {
    let hasError = false;

    if (name.indexOf('phones') === -1) {
      hasError = errors.hasOwnProperty(name);
    } else {
      const parts = name.split('.');
      if (parts.length === 3 && parts[0] === 'phones' & parts[2] === 'number') {
        hasError = errors.hasOwnProperty(parts[0]) && errors[parts[0]].hasOwnProperty(parts[1]);
      }
    }

    return hasError;
  }

  render() {
    const { name, hint } = this.props;

    return (
      <FormikConsumer>
        {({ errors, touched }) => (
          <FormControl label={this.props.label}
            hasError={this.hasTouched(name, touched) && this.hasError(name, errors)}
            className={classNames(
              'form-text',
              this.props.className,
            )}
            showThrobber={this.props.showThrobber}
            name={this.props.name}
            hint={this.props.hint}>
            <Field
              name={this.props.name}
              id={this.props.name}
              placeholder={this.props.placeholder}
              className={classNames('form-text', 'usa-input')}
              disabled={this.props.disabled}
              onKeyUp={this.onChange} />
          </FormControl>
        )}
      </FormikConsumer>
    );
  }
}

TextField.defaultProps = {
  className: [],
  validations: [],
  type: 'text',
  label: '',
  showThrobber: false,
  name: '',
  value: '',
  disabled: false
};

TextField.propTypes = {
  className: PropTypes.array,
  validations: PropTypes.array,
  type: PropTypes.string,
  label: PropTypes.string,
  showThrobber: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool
};

export default TextField;
